@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (box3OverigeOnroerendeZaken.length > 0) {
      <div formArrayName="box3OverigeOnroerendeZaken">
        @for (item of box3OverigeOnroerendeZaken.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <div class="row col-auto" formGroupName="adres" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Land' : ''"
                                                  [options]="optionsLandcodes"
                                                  [required]=true
                                                  class="custom-input-250"
                                                  formControlName="landCode"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-text-form-control [label]="i === 0 ? 'Postcode' : ''"
                                                class="custom-input-100"
                                                formControlName="postcode"
                                                id="postcode"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [label]="i === 0 ? 'Huisnr.' : ''"
                                                  [maxValue]="99999"
                                                  class="custom-input-75"
                                                  formControlName="huisNummer"
                                                  id="huisNummer"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-text-form-control [label]="i === 0 ? 'Toev.' : ''"
                                                class="custom-input-50"
                                                formControlName="huisNummerToevoeging"
                                                id="huisNummerToevoeging"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-text-form-control [label]="i === 0 ? 'Plaats' : ''"
                                                class="custom-input-150"
                                                formControlName="woonplaats"
                                                id="woonplaats"
                >
                </snelstart-ui-text-form-control>
              </div>
              <snelstart-ui-number-form-control [label]="i === 0 ? '% Eigendom' : ''"
                                                [maxValue]="100.00"
                                                [showAllDecimals]="true"
                                                class="custom-input-150"
                                                formControlName="percentageEigendom"
                                                id="percentageEigendom"
                                                label="Percentage eigendom"
                                                postfix="%"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="this.showDialogGegevens(i)"
                                   [class]="i === 0 ? 'pt-3 custom-input-150' : 'custom-input-150'"
                                   icon="plus"
                                   type="secondary">
                Gegevens 1-1
              </snelstart-ui-button>
              <snelstart-ui-button (click)="this.showDialogOwr(i)"
                                   [class]="i === 0 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                                   [disabled]="!heeftOWR"
                                   [icon]="'plus'"
                                   type="secondary">
                OWR
              </snelstart-ui-button>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Onroerende zaak toevoegen
  </snelstart-ui-button>
}

<snelstart-ui-dialog-definition [(visible)]="dialogGegevensVisible" [title]="getGegevensDialogTitel(index)"
                                id="overigeOnroerendeZakenVerhuur" size="lg">
  <snelstart-ui-dialog-body>
    <form [formGroup]="formGroup">
      @if (box3OverigeOnroerendeZaken.length > 0) {
        <div formArrayName="box3OverigeOnroerendeZaken">
          @for (item of box3OverigeOnroerendeZaken.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              @if (i === this.index) {
                <div class="row">
                  <div class="col-7">
                    <p>Is de onroerende zaak gekocht in {{ (incomeTaxEntity$ | async)?.year }}? Vul de aankoopdatum
                      in.</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-date-form-control class="custom-input-250"
                                                    formControlName="datumGekocht"
                                                    id="datumVerkocht"
                                                    label=""
                                                    placeholder="dd-mm-{{(incomeTaxEntity$ | async)?.year}}">
                    </snelstart-ui-date-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
                <div class="row">
                  <div class="col-7">
                    <p>Is de onroerende zaak een woning of een bouwkavel?</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNeeWoning"
                                                      class="custom-input-250"
                                                      formControlName="woning"
                                                      id="woning"
                    >
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
                <div class="row">
                  <div class="col-7">
                    @if (item.get('woning')?.value === true) {
                      <p>Wat is de (verwachte) WOZ-waarde voor {{ (incomeTaxEntity$ | async)?.year }} (peildatum
                        1-1-{{ (incomeTaxEntity$ | async)?.year! - 1 }})?</p>
                    } @else {
                      <p>Vul de waarde van de volle en onbezwaarde eigendom op {{ this.getDatumBegin(i) }} in.
                      </p>
                    }
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-250"
                                                      formControlName="woz"
                                                      id="woz"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                @if (item.get('woning')?.value === true) {
                  <div class="row">
                    <div class="col-7">
                      <p>Jaarbedrag erfpachtcanon in {{ (incomeTaxEntity$ | async)?.year }}</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-number-form-control [decimals]="0"
                                                        align="right"
                                                        class="custom-input-250"
                                                        formControlName="betaaldeErfpachtCanon"
                                                        id="betaaldeErfpachtCanon"
                                                        prefix="€">
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                  </div>
                }

                @if (item.get('adres.landCode')?.value === 'NLD' && item.get('woning')?.value === true) {
                  <div class="row">
                    <div class="col-7">
                      <p>Is de onroerende zaak verhuurd of verpacht in {{ (incomeTaxEntity$ | async)?.year }}?</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                        class="custom-input-250"
                                                        formControlName="isVerhuurdOfVerpacht"
                                                        id="isVerhuurdOfVerpacht">
                      </snelstart-ui-select-form-control>
                    </div>
                    <div class="col-3"></div>
                  </div>
                }

                @if (item.controls.isVerhuurdOfVerpacht.value === true) {
                  <div class="pt-3 pb-3">
                    <b>Gegevens over de verhuur/pacht</b>
                  </div>

                  <div formGroupName="verhuurdOfVerpacht">
                    <div class="row">
                      <div class="col-7">
                        <p>Is de onroerende zaak verhuurd of verpacht?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="verhuurdOfVerpachtStatus"
                                                          class="custom-input-250"
                                                          formControlName="status"
                                                          id="isVerhuurdOfVerpacht">
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>

                    @if (item.get('verhuurdOfVerpacht.status')?.value === VerhuurdOfVerpachtStatus.VERHUURD) {
                      <div class="row">
                        <div class="col-7">
                          <p>Heeft de huurder recht op huurbescherming?</p>
                        </div>
                        <div class="col-2">
                          <snelstart-ui-select-form-control [options]="optionsJaNeeHuurbescherming"
                                                            class="custom-input-250"
                                                            formControlName="huurbescherming"
                                                            id="huurbescherming"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                        <div class="col-3"></div>
                      </div>

                      @if (item.get('verhuurdOfVerpacht.huurbescherming')?.value === true) {
                        <div class="row">
                          <div class="col-7">
                            <p>Huurt de huurder de gehele woning?</p>
                          </div>
                          <div class="col-2">
                            <snelstart-ui-select-form-control [options]="optionsJaNeeVerhuurZelfstandigDeel"
                                                              class="custom-input-250"
                                                              formControlName="zelfstandigDeelVanGroterGebouw"
                                                              id="zelfstandigDeelVanGroterGebouw"
                            >
                            </snelstart-ui-select-form-control>
                          </div>
                          <div class="col-3"></div>
                        </div>

                      <div class="row">
                        <div class="col-7">
                          <p>Is de huurprijs onzakelijk laag vanwege gelieerde verhoudingen?</p>
                        </div>
                        <div class="col-2">
                          <snelstart-ui-select-form-control [options]="optionsJaNeeOnzakelijkeHuur"
                                                            class="custom-input-250"
                                                            formControlName="onzakelijkeHuur"
                                                            id="onzakelijkeHuur">
                          </snelstart-ui-select-form-control>
                        </div>
                        <div class="col-3"></div>
                      </div>

                      @if (item.get('verhuurdOfVerpacht.onzakelijkeHuur')?.value === false) {
                        <div class="row">
                          <div class="col-7">
                            <p>Vul de jaarhuur in (12 x de huur op 1 januari {{ (incomeTaxEntity$ | async)?.year }}
                              ).</p>
                          </div>
                          <div class="col-2">
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              align="right"
                                                              class="custom-input-250"
                                                              formControlName="jaarhuur"
                                                              id="jaarhuur"
                                                              prefix="€">
                            </snelstart-ui-number-form-control>
                          </div>
                          <div class="col-3"></div>
                        </div>
                      }
                      }
                    }
                    @if (item.get('verhuurdOfVerpacht.status')?.value === VerhuurdOfVerpachtStatus.VERPACHT) {
                      <div class="row">
                        <div class="col-7">
                          <p>Is de gehele onroerende zaak verpacht?</p>
                        </div>
                        <div class="col-2">
                          <snelstart-ui-select-form-control [options]="optionsJaNeePachtZelfstandigDeel"
                                                            class="custom-input-250"
                                                            formControlName="zelfstandigDeelVanGroterGebouw"
                                                            id="zelfstandigDeelVanGroterGebouw3">
                          </snelstart-ui-select-form-control>
                        </div>
                        <div class="col-3"></div>
                      </div>
                      <div class="row">
                        <div class="col-7">
                          <p>Heeft de pacht een looptijd van meer dan 12 jaar?</p>
                        </div>
                        <div class="col-2">
                          <snelstart-ui-select-form-control [options]="optionsJaNeeOvereenkomst"
                                                            class="custom-input-250"
                                                            formControlName="overeenkomstMeerDan12Jaar"
                                                            id="overeenkomstMeerDan12Jaar">
                          </snelstart-ui-select-form-control>
                        </div>
                        <div class="col-3"></div>
                      </div>
                      @if (item.get('verhuurdOfVerpacht.overeenkomstMeerDan12Jaar')?.value === true) {
                        <div class="row">
                          <div class="col-7">
                            <p>Is de pacht zakelijk met een niet-gelieerde parij aangegaan?</p>
                          </div>
                          <div class="col-2">
                            <snelstart-ui-select-form-control [options]="optionsJaNeeOnzakelijkePacht"
                                                              class="custom-input-250"
                                                              formControlName="onzakelijkePacht"
                                                              id="onzakelijkePacht">
                            </snelstart-ui-select-form-control>
                          </div>
                          <div class="col-3"></div>
                        </div>
                      }
                      @if (item.get('verhuurdOfVerpacht.onzakelijkePacht')?.value === false) {
                        <div class="row">
                          <div class="col-7">
                            <p>Vul de jaarpacht in (12 x de pacht op 1 januari {{ (incomeTaxEntity$ | async)?.year }}
                              ).</p>
                          </div>
                          <div class="col-2">
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              align="right"
                                                              class="custom-input-250"
                                                              formControlName="jaarpacht"
                                                              id="jaarpacht"
                                                              prefix="€">
                            </snelstart-ui-number-form-control>
                          </div>
                          <div class="col-3"></div>
                        </div>
                      }
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex mt-2">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>


<snelstart-ui-dialog-definition [(visible)]="dialogOwrVisible"
                                [title]="getOWRDialogTitel(index)"
                                id="owrBank"
                                size="lg">
  <snelstart-ui-dialog-body>
    <form [formGroup]="formGroup">
      @if (box3OverigeOnroerendeZaken.length > 0) {
        <div formArrayName="box3OverigeOnroerendeZaken">
          @for (item of box3OverigeOnroerendeZaken.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              @if (i === this.index) {

                <div class="row">
                  <div class="col-7">
                    <p>Is de onroerende zaak verkocht in {{ (incomeTaxEntity$ | async)?.year }}? Vul de verkoopdatum
                      in.</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-date-form-control (change)="saveForm()"
                                                    class="custom-input-250"
                                                    formControlName="datumVerkocht"
                                                    id="datumVerkocht"
                                                    label=""
                                                    placeholder="dd-mm-{{ (incomeTaxEntity$ | async)?.year }}">
                    </snelstart-ui-date-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                <div class="row">
                  <div class="col-7">
                    @if (item.get('woning')?.value === true) {
                      <p>Wat is de (verwachte) WOZ-waarde voor {{ (incomeTaxEntity$ | async)?.year! + 1 }} (peildatum
                        01-01-{{ (incomeTaxEntity$ | async)?.year }})?</p>
                    } @else {
                      <p>Vul de waarde van de volle en onbezwaarde eigendom op {{ this.getDatumEind(i) }} in.
                      </p>
                    }
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-250"
                                                      formControlName="wozPlusEen"
                                                      id="woz"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                @if (item.get('woning')?.value === true) {
                  <div class="row">
                    <div class="col-7">
                      <p>Betaalde erfpachtcanon in {{ (incomeTaxEntity$ | async)?.year }}</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-number-form-control [decimals]="0"
                                                        align="right"
                                                        class="custom-input-250"
                                                        formControlName="betaaldeErfpachtCanonEindeJaar"
                                                        id="betaaldeErfpachtCanonEindeJaar"
                                                        prefix="€">
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                  </div>
                }

                <div class="row">
                  <div class="col-7">
                    <p>Vul het bedrag van de investeringen in {{ jaar }} in (lees de toelichting).</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [minValue]="0"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-250"
                                                      formControlName="investeringen"
                                                      id="woz"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                @if (item.get('investeringen')?.value ?? 0 > 0) {
                  <div class="row">
                    <div class="col-7">
                      <p>Waardestijgiging van de woz als gevolg van de investeringen.</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-number-form-control [decimals]="0"
                                                        [minValue]="0"
                                                        [required]="true"
                                                        align="right"
                                                        class="custom-input-250"
                                                        formControlName="waardestijgingWOZwaardeWegensInvesteringen"
                                                        id="woz"
                                                        prefix="€">
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                  </div>
                }

                <div class="row">
                  <div class="col-7">
                    <p>Ontvangen kale huurprijs in {{ jaar }}.</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      align="right"
                                                      class="custom-input-250"
                                                      formControlName="directRendement"
                                                      id="bedrag"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                @if (item.controls.isVerhuurdOfVerpacht.value === true) {
                  <div class="pt-3 pb-3">
                    <b>Gegevens over de verhuur/pacht op {{ this.getDatumEind(i) }}</b>
                  </div>

                  <div formGroupName="verhuurdOfVerpachtOpEinddatum">
                    <div class="row">
                      <div class="col-7">
                        <p>Is de onroerende zaak verhuurd of verpacht?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="verhuurdOfVerpachtStatus"
                                                          class="custom-input-250"
                                                          formControlName="status"
                                                          id="isVerhuurdOfVerpacht">
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>

                    @if (item.get('verhuurdOfVerpachtOpEinddatum.status')?.value === VerhuurdOfVerpachtStatus.VERHUURD) {
                      <div class="row">
                        <div class="col-7">
                          <p>Heeft de huurder recht op huurbescherming?</p>
                        </div>
                        <div class="col-2">
                          <snelstart-ui-select-form-control [options]="optionsJaNeeHuurbescherming"
                                                            class="custom-input-250"
                                                            formControlName="huurbescherming"
                                                            id="huurbescherming"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                        <div class="col-3"></div>
                      </div>

                      @if (item.get('verhuurdOfVerpachtOpEinddatum.huurbescherming')?.value === true) {
                        <div class="row">
                          <div class="col-7">
                            <p>Huur de huurder de gehele woning?</p>
                          </div>
                          <div class="col-2">
                            <snelstart-ui-select-form-control [options]="optionsJaNeeVerhuurZelfstandigDeel"
                                                              class="custom-input-250"
                                                              formControlName="zelfstandigDeelVanGroterGebouw"
                                                              id="zelfstandigDeelVanGroterGebouw"
                            >
                            </snelstart-ui-select-form-control>
                          </div>
                          <div class="col-3"></div>
                        </div>
                      }

                      @if (item.get('verhuurdOfVerpachtOpEinddatum.onzakelijkeHuur')?.value === true) {
                        <div class="row">
                          <div class="col-7">
                            <p>Vul de jaarhuur in (12 x de huur op 1 januari {{ (incomeTaxEntity$ | async)?.year }}
                              ).</p>
                          </div>
                          <div class="col-2">
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              align="right"
                                                              class="custom-input-250"
                                                              formControlName="jaarhuur"
                                                              id="jaarhuur"
                                                              prefix="€">
                            </snelstart-ui-number-form-control>
                          </div>
                          <div class="col-3"></div>
                        </div>
                      }
                    }
                    @if (item.get('verhuurdOfVerpachtOpEinddatum.status')?.value === VerhuurdOfVerpachtStatus.VERPACHT) {
                      <div class="row">
                        <div class="col-7">
                          <p>Is de gehele onroerende zaak verpacht?</p>
                        </div>
                        <div class="col-2">
                          <snelstart-ui-select-form-control [options]="optionsJaNeePachtZelfstandigDeel"
                                                            class="custom-input-250"
                                                            formControlName="zelfstandigDeelVanGroterGebouw"
                                                            id="zelfstandigDeelVanGroterGebouw3">
                          </snelstart-ui-select-form-control>
                        </div>
                        <div class="col-3"></div>
                      </div>
                      <div class="row">
                        <div class="col-7">
                          <p>Heeft de pacht een looptijd van meer dan 12 jaar?</p>
                        </div>
                        <div class="col-2">
                          <snelstart-ui-select-form-control [options]="optionsJaNeeOvereenkomst"
                                                            class="custom-input-250"
                                                            formControlName="overeenkomstMeerDan12Jaar"
                                                            id="overeenkomstMeerDan12Jaar">
                          </snelstart-ui-select-form-control>
                        </div>
                        <div class="col-3"></div>
                      </div>
                      @if (item.get('verhuurdOfVerpachtOpEinddatum.overeenkomstMeerDan12Jaar')?.value === true) {
                        <div class="row">
                          <div class="col-7">
                            <p>Is de pacht zakelijk met een niet-gelieerde parij aangegaan?</p>
                          </div>
                          <div class="col-2">
                            <snelstart-ui-select-form-control [options]="optionsJaNeeOnzakelijkePacht"
                                                              class="custom-input-250"
                                                              formControlName="onzakelijkePacht"
                                                              id="onzakelijkePacht">
                            </snelstart-ui-select-form-control>
                          </div>
                          <div class="col-3"></div>
                        </div>
                      }
                      @if (item.get('verhuurdOfVerpachtOpEinddatum.onzakelijkePacht')?.value === false) {
                        <div class="row">
                          <div class="col-7">
                            <p>Vul de jaarpacht in (12 x de pacht op 1 januari {{ (incomeTaxEntity$ | async)?.year }}
                              ).</p>
                          </div>
                          <div class="col-2">
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              align="right"
                                                              class="custom-input-250"
                                                              formControlName="jaarpacht"
                                                              id="jaarpacht"
                                                              prefix="€">
                            </snelstart-ui-number-form-control>
                          </div>
                          <div class="col-3"></div>
                        </div>
                      }
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    </form>


    <!--              &lt;!&ndash; WOZ EIND &ndash;&gt;-->
    <!--              -->
    <!--              <div class="pt-2 pb-2">-->
    <!--                <div class="d-flex align-items-center">-->
    <!--                  <div class="result-inline">-->
    <!--                    @let rendementOG = getBerekendeWerkelijkRendement(i);-->
    <!--                    Berekend werkelijk rendement {{ this.jaar }}:-->
    <!--                    € {{ rendementOG | number:'1.0-0' }}-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->

    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--    </form>-->
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons>
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

